<template>
    <div :class="['input_group', { 'image_error': error }]">
        <button type="button" @click="triggerFileInput" class="image_upload">
            <h4 v-if="fileSelected">Arquivo selecionado</h4>
            <h4 v-else>Selecionar arquivo</h4>
            <span v-if="fileSelected">{{ fileSelected }}</span>
            <span v-else>Tamanho máximo: 2 MB</span>
        </button>
        <input ref="fileInput" type="file" @change="handleFileChange" class="file_input" accept="image/*" />    
        <span v-if="error" class="error_message">{{ error[0] }}</span>
    </div>
</template>
  
<script setup>
import { ref, defineProps, defineEmits } from 'vue'

defineProps({
    error: String
})

const emits = defineEmits(['update:modelValue'])
const fileSelected = ref(null)
const fileInput = ref(null)

function handleFileChange(event) {
    const file = event.target.files[0]
    if (file) {
        fileSelected.value = file.name;
        emits('update:modelValue', file)
    }
}

function triggerFileInput() {
    fileInput.value.click()
}
</script>
  
<style scoped>
.image_upload {
    height: 90px;
    background-color: #fff;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    cursor: pointer;
    border: 0;
    width: 100%;
    border: 2px #ccc dashed;
}

.image_upload:hover {
    background-color: #f1f1f1;
}

.image_upload h4 {
    font-size: 16px;
    margin-bottom: 0;
}

.image_upload span {
    font-size: 14px;
    font-weight: 500;
    color: #7f7f7f;
}

.dark .image_upload {
    background-color: #232932;
    border-color: #394251;
    color: #b5b9d0;
}

.file_input {
    display: none;
}

.image_error button {
    border: 1px #df2b2b solid;
    color: #df2b2b;
    box-shadow: 0px 0px 0px 3px rgb(255 136 136 / 30%);
}

.error_message {
    color: #df2b2b;
    font-weight: 500;
    margin-top: 4px;
    display: block;
}
</style>
  